function Loading() {
  return (
    <div className="w-8 h-8 m-1 ease-linear border-4 border-t-4 border-white border-opacity-25 rounded-full loader" />
  );
}

export default Loading;
